/**
 * Normalises an API boolean flag that the backend serialises inconsistently
 * across environments — real `true`/`false`, `1`/`0`, the strings `"1"`/`"0"`
 * or `"true"`/`"false"`, or `null` for never-set values. Returns `true` only
 * for an affirmative signal; everything else (including `"0"` and `"false"`,
 * which are truthy in JS) is `false`. Use it instead of a raw `=== true` or
 * truthy check whenever branching on a backend boolean.
 */
export const isAffirmative = (value: unknown): boolean => {
  if (value === true || value === 1) {
    return true;
  }
  if (typeof value === "string") {
    const normalised = value.trim().toLowerCase();
    return normalised === "1" || normalised === "true";
  }
  return false;
};
